import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import type { FetchFranchisesOptions } from '../location.api'
import { fetchFranchises } from '../location.api'
import { locationsQueryKeys } from '../location.queryKeys'
import type { FranchiseSchema } from '../types/Franchise.schema'

export const useFetchFranchises = (
  request: FetchFranchisesOptions,
  queryOptions?: UseAppQueryOptions<FranchiseSchema[]>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: locationsQueryKeys.franchises.all(),
    queryFn: () => fetchFranchises(request)
  })
}
